exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\n:host {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n:host div.imagery {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n:host .map-loader-wrapper {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  background-color: #2E2D46;\n}\n:host .map-loader-wrapper.lowered {\n  position: absolute;\n  top: 3px;\n  width: calc(100% - 6px);\n  margin-left: 3px;\n}\n:host .map-loader-wrapper .map-loader {\n  height: 3px;\n  background-color: #d393e1;\n}\n:host /deep/ .ol-scale-line {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 0;\n  bottom: 0;\n  left: 0;\n  padding: 3px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/map-facade/components/imagery-container/imagery-container.component.less
// module id = ../../../../../src/app/packages/map-facade/components/imagery-container/imagery-container.component.less
// module chunks = main